
export default function expense( state = [], action = {} ){

	switch( action.type ){
		case 'SAVE_EXPENSE':
            return action.expense
        case 'EXP_GET_USERS':
            return action.expense
        case 'GET_EXPENSE':
            return action.expense
        case 'DELETE_EXPENSE':
            return action.expense
        case 'UPDATE_EXPENSE':
            return action.expense
		default: return state;
	}
		
}




// WEBPACK FOOTER //
// ./src/store/reducers/expense/expense.reducer.js